/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter an A260 value to calculate the concentration.`)
};

const es_od_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un valor de A260 para calcular la concentración.`)
};

const de_od_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen A260-Wert ein, um die Konzentration zu berechnen.`)
};

const nl_od_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een A260-waarde in om de concentratie te berekenen.`)
};

const fr_od_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez une valeur A260 pour calculer la concentration.`)
};

const it_od_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un valore A260 per calcolare la concentrazione.`)
};

const pt_br2_od_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um valor de A260 para calcular a concentração.`)
};

const pt_od_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um valor de A260 para calcular a concentração.`)
};

const ja_od_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260の値を入力すると濃度が計算されます。`)
};

const zh_od_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入 A260 值以计算浓度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_hint_empty", locale)
	if (locale === "en") return en_od_hint_empty(inputs)
	if (locale === "es") return es_od_hint_empty(inputs)
	if (locale === "de") return de_od_hint_empty(inputs)
	if (locale === "nl") return nl_od_hint_empty(inputs)
	if (locale === "fr") return fr_od_hint_empty(inputs)
	if (locale === "it") return it_od_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_od_hint_empty(inputs)
	if (locale === "pt") return pt_od_hint_empty(inputs)
	if (locale === "ja") return ja_od_hint_empty(inputs)
	return zh_od_hint_empty(inputs)
};